import { atom } from "recoil";
import { SESSION_END_LAYOUT } from "../../constants/enums";
import { SessionEndModalSettings, SessionEndPageSettings } from "../../context/types";


export const sessionEndModalAtom = atom<SessionEndModalSettings>({
  key: "sessionEndModalAtom",
  default: null
})

export const isDurationAlertDisplayedAtom = atom({
  key: "isDurationAlertDisplayedAtom",
  default: false
})

export const sessionEndPageAtom = atom<SessionEndPageSettings>({
  key: "sessionEndPageAtom",
  default: null
})

export const sessionEndLayoutAtom = atom({
  key: 'sessionEndLayoutAtom',
  default: SESSION_END_LAYOUT.PAGE, // Assuming the default value is 1 (page)
});
